import React from "react";
import SuccessModal from "../../../../../organisms/Modal/SuccessModal/SuccessModal";
import ErrorModal from "../../../../../organisms/Modal/ErrorModal/ErrorModal";
import {NoSsr} from "@material-ui/core";
import {compose} from "recompose";
import {withTranslation} from "react-i18next";
let t=null;

class PublishWeb extends React.Component {

    constructor(props){
        super(props);
        t = props.t;
    }

    showMessages = () => {

        if( this.props.publishWeb.publishWebData && this.props.publishWeb.publishWebData.status === 200){
            const message = this.props.isPublish === 0
                ? t('enw-web-unpublish-site', 'Web siteniz yayından kaldırıldı.')
                : t('enw-web-publish-site');

            // Modal kapanınca site verisini tazele; yayın durumu değiştiği için
            // doğru buton (Yayınla / Yayından Kaldır) sayfa yenilenmeden gelsin
            return <SuccessModal
                status={true}
                message={ message }
                toggle={ () => {} }
                handleFonction={ () => {
                    if (typeof this.props.onSuccessClose === 'function') {
                        this.props.onSuccessClose();
                    }
                }}
            />
        } else if (this.props.publishWeb.errorPublish && this.props.publishWeb.errorPublish.response !== undefined ) {
            let message = this.props.publishWeb.errorPublish.response.data.message
            return  <ErrorModal status={true} message={message}/>
        }
    }

    render() {
        return (
            <NoSsr>
                {
                    !this.props.publishWeb.fetchingPublish &&
                        <NoSsr>
                            {
                                this.showMessages()
                            }
                        </NoSsr>
                }

            </NoSsr>
        )
    }
}

export default compose(withTranslation('common')) (PublishWeb);
